export default __webpack_public_path__ + "static/media/flag.8d48322a.svg";